import Filter from './filter';

export default class RangeFilter extends Filter {
    constructor(datasetName, initialRange = {
        min: 0,
        max: 0
    }) {
        super();
        this.datasetName = datasetName;
        this.range = initialRange;
    }

    update(range = {
        min: this.range.min,
        max: this.range.max
    }) {
        this.range = range;
    }

    _test(target) {
        let value = parseInt(target.dataset[this.datasetName]);
        return this.range.min <= value && this.range.max >= value;
    }
}